import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { reducer } from './reducer'
import i18n from 'live/services/i18n'
import DrillDownMap from './DrillDownMap'
import { Configs, DrillDownMapState, DrillDownMessage } from './types'
import ConfigForm from './ConfigForm'
import locale from 'live/init/global-locale'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

var localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}

i18n.add(localeFiles[locale])

widgetService.register({
    type: 'DrillDownMap',
    get name() {
        return i18n('Drill Down Map')
    },
    get description() {
        return i18n('This widget show the polyline in map')
    },
    config: {
        key: 'digite a chave',
        steps: 5,
        zoom: 15,
        extensionQualifier: '',
        perspectives: [],
        lookupParameters: ''
    },
    ui: { configForm: ConfigForm },
    policies: { handleOwnMissingData: true },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<DrillDownMapState, DrillDownMessage>(DrillDownMap, reducer)
})